<div class="modal-header">
  <h4 id="assign-item-modal" class="modal-title">{{ "Assign" | translate }}</h4>
  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <p>
    {{
      "If you assign this item to a specific moderator, only they will be able to review it or unassign themselves."
        | translate
    }}
  </p>

  <form [formGroup]="form">
    <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
  </form>

  <astrobin-loading-indicator *ngIf="loadingAssignees"></astrobin-loading-indicator>
</div>

<div class="modal-footer">
  <button (click)="modal.dismiss()" class="btn btn-outline-secondary" type="button">
    {{ "Cancel" | translate }}
  </button>

  <button
    [class.loading]="loadingService.loading$ | async"
    [disabled]="model.assignee === item.assignee"
    (click)="save()"
    class="btn btn-success"
    type="button"
  >
    {{ "Save" | translate }}
  </button>
</div>
